import React from 'react'
import { Footer } from '../../components/Footer'
import { Header } from '../../components/Header'
import HeadMeta from '../../components/HeadMeta'
import { GetServerSideProps } from 'next';
import camelcaseKeys from 'camelcase-keys'
import { MagazineBody } from '../../components/MagazineBody'

export interface Magazine {
  id: number
  title: string
  eyeCatchImage: string
  flagNew: boolean
  baseSite: MagazineBaseSite | null
  tags: string[]
  blocks: MagazineBlock[]
  publishedAt: string
  createdAt: string // not use
  updatedAt: string
}

export interface MagazineBaseSite {
  id: number
  key: string
  name: string
}

export interface MagazineBlock {
  id: number
  blockType: string // refs api doc for swagger.yaml: https://betsudai.backlog.jp/alias/wiki/1188719
  order: number
  magazineId: number
  title: string | null
  description: string | null
  magazineImageBlock: MagazineImageBlock | null
  magazineTwoImagesBlock: MagazineImageBlock[] | null
  magazineThirdImagesBlock: MagazineImageBlock[] | null
}

export interface MagazineImageBlock {
  id: number
  image: {
    url: string
    thumb: {
      url: string
    }
  }
  alt: string
  imageIndex: number | null
  caption: string
  imageableId: number
  imageableType: string
  // createdAt: string // not use
  // updatedAt: string // not use
  // forceUpdatedAt: string | null // not use
}

export interface MagazineTag {
  id: number
  name: string
  tag_type: string
  createdAt: string // not use
  updatedAt: string // not use
}

interface PickupDetailPageProps {
  pickup: Magazine
}

function getDescription(descBlock: MagazineBlock | undefined) {
  if (descBlock != undefined && descBlock.description != null) {
    return descBlock.description.replace(/<[^>]+>|\&\w*;/g, '')
  } else {
    return ''
  }

}

const PickupDetailPage = ({ pickup }: PickupDetailPageProps) => {
  // MEMO: テキストブロックの最初のブロックを取得
  const descriptionFirstBlocks = pickup.blocks.find((block) => block.blockType === 'Magazines::MagazineDescBlock');
  const metaDesc = getDescription(descriptionFirstBlocks);

  return (
    <div>
      <HeadMeta title={`${pickup.title}｜特集｜株式会社ベツダイ`} description={metaDesc} />
      <noscript>
        &lt;style&gt;body{'{'}visibility:visible{'}'}&lt;/style&gt;
      </noscript>
      <div className="c-page-sub__base">
        <div className="c-page-sub__header">
          <Header />
        </div>
        <div className="c-page-sub__breadcrumb">
          <div className="c-nav-breadcrumb">
            <ol>
              <li className="c-nav-breadcrumb__item"><a href="/">トップ</a></li>
              <li className="c-nav-breadcrumb__item"><a href="/pickup/">特集</a></li>
              <li className="c-nav-breadcrumb__item" data-breadcrumb="current">{pickup.title}</li>
            </ol>
          </div>
        </div>
        <div className="c-page-sub__main" data-page="pickup-detail">
          <main className="c-page-sub__content">
            <article data-page="pickup-detail">
              <div className="c-page-sub__title-page">
                <div className="c-title-page" data-page="default">
                  <h1><span data-lang="en">PICK UP</span><span data-lang="ja">特集</span></h1>
                </div>
              </div>
              <div className="c-page-sub__content-main">
                <div className="c-pickup">
                  <div className="c-pickup__detail-title">
                    <h2 data-item="title">{pickup.title}</h2>
                    <div className="c-pickup-tag-group">
                      {pickup.tags.map((tag, index) => (
                        <span key={index} data-type="category" className="pickup-tag">#{tag}</span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="c-content-main html-content">
                  <MagazineBody magazine={pickup} />
                </div>
              </div>
              <div className="c-page-sub__pagination" data-page="detail">
                <nav className="c-pagination" data-type="detail">
                  <div className="c-pagination__button"><a href="/pickup">一覧に戻る</a></div>
                </nav>
              </div>
            </article>
          </main>
        </div>
        <div className="c-page-sub__footer">
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default PickupDetailPage

export const getServerSideProps: GetServerSideProps = async (context) =>{

  var pickup: Magazine
  const displaySite = 'corporate';
  const id = context.query.id;

  const authHeader = new Headers();
  authHeader.append('X-CLIENT-ID', process.env.CLIENT_ID || '');
  authHeader.append('X-CLIENT-SECRET', process.env.CLIENT_SECRET || '');

  try {
    const response = await fetch(`${process.env.API_HOST}/api/v1/magazines/${id}?display_site=${displaySite}`, {
      headers: authHeader,
    })
    const data = await response.json();
    console.log(data)
    pickup = data.magazine
  } catch(e) {
    console.log(`ERROR: ${e}`)
    throw new Error
  }

  return {
    props: {
      pickup: pickup ? camelcaseKeys(pickup, { deep: true }) : pickup,
    }
  };
}
